import { useIntl } from "react-intl";
import BaseInput from "./BaseInput";
import BaseButton from "components/common/BaseButton";
import CircleCloseFilterSvg from "components/svg/CircleCloseFilter";

interface Props {
  searchInput: string;
  placeholder: string;
  onSearchInputChange: (value: string) => void;
}

function HeaderSearchInput({
  searchInput,
  placeholder,
  onSearchInputChange,
}: Props) {
  const intl = useIntl();

  return (
    <div className="form_control usadmin-search--wrapper">
      <label className="usadmin-search-label">
        {intl.formatMessage({ id: "dashboard.searchSubmit" })}
      </label>
      <div className="usadmin-search-wrapper">
        <BaseInput
          name="search"
          placeholder={placeholder}
          value={searchInput}
          onChange={(e) => onSearchInputChange(e.target.value)}
          containerClassName="usadmin-search-input"
          className="usadmin-search-input--wrapper"
        />
        <BaseButton
          className="usadmin__clear-button button--no-background"
          iconComponent={<CircleCloseFilterSvg />}
          handleSubmit={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            onSearchInputChange("");
          }}
        />
      </div>
    </div>
  );
}

export default HeaderSearchInput;
